var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalmTree2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 22,
    fill: "url(#pattern0_2791_409)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2791_409",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2791_409",
    transform: "scale(0.047619 0.0454545)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2791_409",
    width: 21,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxElEQVQ4ja2TPWtUQRSGn90sGsJKttCEiBoVQazF3jJIJMbCwsrC1mZBsJIUFlYiYmElKP4BwUbED7CQqFUKBRU00UIUJNEQwUAeiz3XHcd7zQ36wnDunI/3znnPDCrZOmsPH9QZdXNJzkl1Tl1T76jNNJ4nF+uifTxWh8PfUC8nsQdJbF1S1AsZcVM9nxEOldX+jRS1q66oC+o29Xu0fKtCFlRa9LELOA7sBAaAr8BTYC8wBRwE3gMnIt4FRqP2E3AfmAV+nfSMumo5nqgj6iF1u3qtIs/oYFND3QNcAhr8ic/AK2AOuAvsB44CO4DxiprrLeAtMF0S3BoE+4Af4VsGtgCvgavAm5K6ykF11eVo6VlM+ZE6rl4J/5p6Q23Xmf65RKN36mj4VQ+rA+rtJOeevftbSTpi79qoLqoHkpjqRHwPqc8T4umUp5mpMQEMAquh88vwd8IOhl0BJoH52B9LSXLSsbCngYelQ+jjI3AEWErqSkm/ATPAzcxfPJJ25n9B78F8+c2baTqcix5rd2h3quK2dNJ9K/vz0jotV2Ex3eTtV6EYUKdO8kZJa6EuaYFcrn8ibWf2v5DWOuFGSQvU0vYnB+uYswPOHC4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmTree2);
export default __webpack_public_path__ + "static/media/palm-tree-2.b4fb5fc450242d71685cd03ff835d913.svg";
export { ForwardRef as ReactComponent };